var parameterInsert={
    IdEnterprise:'',
    NameUser:'',
    Email:'',
    Password:'',
    Position:'',
    TypeAccount:'', 
    Active:'1',
    IsResponsible:'2',
    User:'',
    IP:'',
    IdDivision:'1'
} 
var parameterUpdate={
    IdUser:'',
    NameUser:'',
    Email:'',
    Password:'',
    Position:'',
    TypeAccount:'', 
    Active:'1',
    IsResponsible:'',
    User:'',
    IP:'',
    IdDivision:'1'
} 
var parameterResetPassword={
    IdUser:'',
    NewPassword:'',
    CheckNewPassword:'', 
    Active:'1',
    User:'',
    IP:''
} 
var parameterView={ 
    IdEnterprise:'',
    NameUser:'', 
    Email:'',
    Active:'2',
    IdDivision:'1'
} 
export default
{
    parameterInsert,
    parameterUpdate,
    parameterView
}